<template>
  <div>
    <h4 v-if="this.data.title">{{ this.data.title }}</h4>
    <table class="table table-striped table-bordered">
      <tbody>
        <tr>
          <th v-for="(header, index) in this.headers" :key="index">{{ header }}</th>
        </tr>
        <template v-for="(rows, group) in this.rowsByGroup">
          <tr v-for="(row, index) in rows">
            <td v-if="index === 0 && group !== 'undefined'" :rowspan="rows.length">{{group}}</td>
            <td v-for="(cell, index) in rows.shift()" :key="index">
              <span v-html="formatterByDataType[cell.dataType](cell.value)"></span>
            </td>
          </tr>
        </template>
        <template v-if="Object.keys(this.rowsByGroup).length === 0">
          <tr>
            <td :colspan="this.headers.length">Não há informações para este relatório no ano selecionado.</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'TableReport',
    props: ['data'],
    data () {
      return {
        formatterByDataType: {
          'text': function (value) {
            if (value === '') return '-'
            return value
          },
          'currency': function (value) {
            let formatter = Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2})
            return formatter.format(value)
          },
          'percentage': function (value) {
            return Number(value).toFixed(2).replace('.', ',')
          },
          'integer': function (value) {
            return Number(value).toLocaleString('pt-BR')
          }
        }
      }
    },
    computed: {
      headers: function () {
        if (!this.data.report || !this.data.report.rows) return []

        const firstColumnIsEmpty = this.data.report.rows.filter(r => r.hasOwnProperty('group')).length > 0
        if (firstColumnIsEmpty) {
          return [...[''], ...this.data.report.columns]
        }

        return [...this.data.report.columns]
      },
      rowsByGroup: function () {
        if (!this.data.report || !this.data.report.rows) return []

        const rowsByGroup = {}
        this.data.report.rows.forEach(r => {
          if (!rowsByGroup.hasOwnProperty(r.group)) {
            rowsByGroup[r.group] = []
          }
          rowsByGroup[r.group].push(r.cells)
        })

        return rowsByGroup
      }
    }
  }
</script>

<style scoped>
  h4, table {
    color: #333;
  }
  th {
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// TableReport.vue?4a751c18